<template>
    <CustomDialog :value="isCloseSale" :defaultTitle="$t('checkout.sale.close_sale_title')" @cancel="$emit('close-sale-modal')">
        <template #content>
            <div class="block-content text-left mb-0 py-0 px-4">
                <p class="fs-6 fw-medium my-24 ppv2-text-black text-center f-poppin">
                    {{ $t('checkout.sale.close_sale_confirm') }}
                </p>
                <div v-if="data.send_invoice" id="container_company" class="form-group mb-2">
                    <CustomInput
                        type="text"
                        :label="$t('checkout.sale.add_company')"
                        :required="true"
                        v-model="data.company_name"
                    />
                    <div class="row d-flex gap-2 my-3">
                        <div class="col-12 py-1 mb-3">
                            <CustomInput
                                type="text"
                                :label="$t('checkout.sale.address')"
                                :required="true"
                                v-model="data.company_address.address"
                            />
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 w-100 py-1 mb-3">
                                <CustomInput
                                    type="text"
                                    :label="$t('checkout.sale.postal_code')"
                                    :required="true"
                                    v-model="data.company_address.cp"
                                />
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 w-100 py-1 mb-3">
                                <CustomInput
                                    type="text"
                                    :label="$t('checkout.sale.country')"
                                    :required="true"
                                    v-model="data.company_address.country"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="data.send_mail" class="mb-2">
                    <div class="d-flex gap-2 my-32">
                        <img src="/media/mail-remerciement.png" alt="mail-icon" height="20" />
                        <label class="fs-6 fw-medium ppv2-text-black f-poppin">{{ $t('checkout.thanks_mail.title') }}</label>
                    </div>
                    <div class="d-flex mt-2 mb-5 gap-2 flex-wrap">
                        <div class="form-check d-flex align-items-center gap-1" style="padding-left: 0">
                            <input
                                style="height: 18px; width: 18px"
                                id="rebooking-modal"
                                class="form-check-input"
                                type="radio"
                                :checked="data.rebooking"
                                @change="
                                    (event) => {
                                        event.target.checked ? (data.rebooking = true) : (data.rebooking = false)
                                    }
                                "
                            />
                            <label for="rebooking-modal" class="fs-sm poppinsMedium ppv2-text-black">{{
                                $t('checkout.thanks_mail.rebooking')
                            }}</label>
                        </div>
                        <div class="form-check d-flex align-items-center gap-1" style="padding-left: 0">
                            <input
                                style="height: 18px; width: 18px"
                                id="notice-modal"
                                class="form-check-input"
                                type="radio"
                                :checked="data.notice"
                                @change="
                                    (event) => {
                                        event.target.checked ? (data.notice = true) : (data.notice = false)
                                    }
                                "
                            />
                            <label for="notice-modal" class="fs-sm poppinsMedium ppv2-text-black">{{
                                $t('checkout.thanks_mail.notice_links')
                            }}</label>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-row justify-content-center align-items-center pb-3 mt-3 flex-wrap gap-3">
                    <div class="form-switch p-0" style="padding-left: 0">
                        <button
                            style="height: 40px; background-color: #fbd080"
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-12"
                            :class="data.send_mail ? ' text-white' : 'text-white'"
                            @click="
                                () => {
                                    data.send_mail = !data.send_mail
                                    if (!data.send_mail) {
                                        data.rebooking = false
                                        data.notice = false
                                    }
                                }
                            "
                            ref="sendMailBtn"
                        >
                            <i
                                class="fa fa-xs fa-fw fa-check pe-2"
                                :class="data.send_mail ? 'd-inline-block' : 'd-none'"
                                ref="sendMailIcon"
                            ></i
                            >{{ $t('checkout.thanks_mail.title') }}
                        </button>
                    </div>
                    <div class="form-switch p-0">
                        <button
                            style="width: 148px; height: 40px; background-color: #fbd080"
                            type="button"
                            role="button"
                            class="btn btn-sm rounded-12"
                            :class="data.send_invoice ? ' text-white' : 'text-white'"
                            @click="
                                () => {
                                    data.send_invoice = !data.send_invoice
                                    if (!data.send_invoice) {
                                        data.company_name = null
                                        data.company_address = {
                                            address: null,
                                            cp: null,
                                            country: null,
                                        }
                                    }
                                }
                            "
                            ref="sendInvoiceBtn"
                        >
                            <i
                                class="fa fa-xs fa-fw fa-check pe-2"
                                :class="data.send_invoice ? 'd-inline-block' : 'd-none'"
                                ref="sendInvoiceIcon"
                            ></i
                            >{{ $t('checkout.sale.invoice') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <template #actions>
            <BaseButton variant="outline" @click="hideModal('encaisser')" customClass="!ppv2-min-h-[40px]">
                {{ $t('checkout.sale.cash_in_only') }}
            </BaseButton>
            <BaseButton variant="primary" @click="hideModal('cloturer')" customClass="!ppv2-min-h-[40px]">
                {{ $t('checkout.sale.close') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
export default {
    props: ['closeSaleModal', 'companyName', 'companyAddress', 'sendInvoice', 'sendMail', 'parameterThanks'],
    components: {
        CustomDialog: () => import('../../Shared/CustomDialog.vue'),
        CustomInput: () => import('../../Inputs/CustomInput.vue'),
        BaseButton: () => import('../../Shared/BaseButton.vue'),
    },
    data: () => ({
        isCloseSale: false,
        data: {
            close_sale: true,
            company_name: null,
            company_address: {
                address: null,
                cp: null,
                country: null,
            },
            rebooking: false,
            notice: false,
            send_mail: false,
            send_invoice: false,
        },
    }),
    created() {
        this.data.send_invoice = this.sendInvoice
        this.data.send_mail = this.sendMail
    },
    mounted() {
        this.isCloseSale = this.closeSaleModal
        this.data.company_name = this.companyName
        this.data.company_address = this.companyAddress
        this.data.rebooking = this.parameterThanks.rebooking
        this.data.notice = this.parameterThanks.notice
    },
    methods: {
        hideModal(type = null) {
            if (type == 'encaisser') {
                this.data.close_sale = false
            } else if (type == 'cloturer') {
                this.data.close_sale = true
            }
            this.$emit('close-sale', this.data)

            // this.isCloseSale = !this.isCloseSale
        },
    },
    watch: {
        closeSaleModal(newVal) {
            this.isCloseSale = newVal
        },
    },
}
</script>
